import { useDispatch } from 'react-redux';
import { CustomAlert } from '../../../shared/uiComponents';
import { DispatchProperties, useSelector } from '../../../redux/store';
import { setAddDiscretionary } from '../../../redux/State/clientSlice/calendarHelperSlice';
import AdminHoursForm from './adminHoursForm';

const AddDiscretionaryHours = () => {
	const dispatch = useDispatch<DispatchProperties>();
	const open = useSelector((state) => state.calendarHelper.popups.addDiscretionary);
	const close = () => dispatch(setAddDiscretionary(false));

	return (
		<CustomAlert
			open={open}
			onClose={close}
			titleOnTop={false}
			title="Log Admin Hours"
			Content={() => <AdminHoursForm onClose={close} />}
		/>
	);
};

export default AddDiscretionaryHours;
